// eslint-disable-next-line import/prefer-default-export
import { SORTING_OPTIONS } from '../../constants';
export var getLastCardId = function (cardIds) {
    if (!cardIds.length) {
        return undefined;
    }
    return cardIds.reduce(function (minId, _id) { return (_id < minId ? _id : minId); }, cardIds[0]);
};
export var getCardRatingDestructor = function (_a) {
    var rating = _a.cardTemplate.rating;
    return rating;
};
var getIdOrder = function (_a, _b) {
    var id1 = _a._id;
    var id2 = _b._id;
    if (id1 > id2)
        return 1;
    if (id1 < id2)
        return -1;
    return 0;
};
var getRatingOrder = function (item1, item2) {
    return getCardRatingDestructor(item1) - getCardRatingDestructor(item2);
};
export function compareCards(item1, item2, sortOrder) {
    switch (sortOrder) {
        case SORTING_OPTIONS.DATE_ASCENDING:
            return getIdOrder(item1, item2);
        case SORTING_OPTIONS.DATE_DESCENDING:
            return -getIdOrder(item1, item2);
        case SORTING_OPTIONS.RATING_ASCENDING:
            return getRatingOrder(item1, item2);
        case SORTING_OPTIONS.RATING_DESCENDING:
            return -getRatingOrder(item1, item2);
        default:
            return 0;
    }
}
